import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "nameInput", "bgColorInput", "textColorInput", "borderColorInput"]
  
  connect() {
    this.updatePreview()
  }
  
  adjustBorderColorFromBg(event) {
    event.preventDefault()
    
    if (!this.hasBgColorInputTarget || !this.hasBorderColorInputTarget) return
    
    const bgColor = this.bgColorInputTarget.value
    if (!bgColor) return
    
    const darkerColor = this.darkenColor(bgColor, 20)
    this.borderColorInputTarget.value = darkerColor
    
    if (this.borderColorInputTarget.dataset.colorSyncTarget === "input") {
      const inputEvent = new Event('input', { bubbles: true })
      this.borderColorInputTarget.dispatchEvent(inputEvent)
    }
    
    this.updatePreview()
  }
  
  darkenColor(color, percent) {
    const num = parseInt(color.replace("#", ""), 16)
    const amt = Math.round(2.55 * percent)
    const R = (num >> 16) - amt
    const G = (num >> 8 & 0x00FF) - amt
    const B = (num & 0x0000FF) - amt
    return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
      (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
      (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1)
  }
  
  updatePreview() {
    const name = this.hasNameInputTarget ? this.nameInputTarget.value : "ラベル名"
    const bgColor = this.hasBgColorInputTarget ? this.bgColorInputTarget.value : "#EF4444"
    const textColor = this.hasTextColorInputTarget ? this.textColorInputTarget.value : "#FFFFFF"
    const borderColor = this.hasBorderColorInputTarget ? this.borderColorInputTarget.value : ""
    
    // プレビューのHTMLを更新
    this.previewTarget.innerHTML = this.createLabelHtml(name, bgColor, textColor, borderColor)
  }
  
  createLabelHtml(name, bgColor, textColor, borderColor) {
    const cssVars = this.buildCssVariables(bgColor, textColor, borderColor)
    const classes = this.buildClasses(borderColor)
    
    return `<span class="${classes}" style="${cssVars}">${this.escapeHtml(name || "ラベル名")}</span>`
  }
  
  buildCssVariables(bgColor, textColor, borderColor) {
    let vars = `--label-bg-color: ${bgColor}; --label-text-color: ${textColor}`
    if (borderColor) {
      vars += `; --label-border-color: ${borderColor}`
    }
    return vars
  }
  
  buildClasses(borderColor) {
    let classes = "label-badge inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
    classes += " bg-[var(--label-bg-color)] text-[var(--label-text-color)]"
    if (borderColor) {
      classes += " border border-[var(--label-border-color)]"
    }
    return classes
  }
  
  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}